module.exports = __webpack_public_path__ + "img/collection-weddingRingsHearts@2x.304ba86.jpg";